import some from 'lodash/some';

export const canUnarchivePage = (operations) => {
	return some(operations, { targetType: 'page', operation: 'archive' });
};

export const canDeletePage = (operations) =>
	some(operations, { targetType: 'page', operation: 'delete' });
